import EditNoteIcon from '@mui/icons-material/EditNote';
import { Menu, Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import React, { type FC } from 'react';

import useSnackBar from '../../hooks/use-snack-bar.js';
import LogForm from '../Logs/LogForm.js';

interface StreamsLogsMenuProps {
  setExpansionLocked: (value: boolean) => void;
  patientId: string;
  refetchLogs: () => void;
}
const StreamLogsMenu: FC<StreamsLogsMenuProps> = ({ setExpansionLocked, patientId, refetchLogs }) => {
  const [logsMenuAnchorEl, setLogsMenuAnchorEl] = React.useState<null | HTMLElement>(null);
  const logsMenuOpen = Boolean(logsMenuAnchorEl);
  const snackBar = useSnackBar();

  const handleLogsMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setExpansionLocked(true);
    setLogsMenuAnchorEl(event.currentTarget);
  };
  const handleLogsMenuClose = () => {
    setLogsMenuAnchorEl(null);
    setExpansionLocked(false);
  };

  const confirmLogSaved = () => {
    snackBar.success('Log updated successfully!');
  };
  return (
    <>
      <Tooltip arrow color="primary" placement="bottom" title={'Add a new log'}>
        <IconButton
          sx={{ color: 'white' }}
          id="logs-menu-button"
          aria-controls={logsMenuOpen ? 'logs-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={logsMenuOpen ? 'true' : undefined}
          onClick={handleLogsMenuClick}
        >
          <EditNoteIcon />
        </IconButton>
      </Tooltip>
      <Menu
        id="logs-menu"
        anchorEl={logsMenuAnchorEl}
        open={logsMenuOpen}
        onClose={handleLogsMenuClose}
        MenuListProps={{
          'aria-labelledby': 'logs-menu-button',
        }}
        sx={{
          '& .MuiMenu-paper': {
            width: 300,
            p: 1,
          },
        }}
      >
        <LogForm
          patientId={patientId}
          onSuccess={() => {
            confirmLogSaved();
            handleLogsMenuClose();
            refetchLogs();
          }}
        />
      </Menu>
    </>
  );
};

export default StreamLogsMenu;
